import { ButtonUI } from 'sonata-react-components';

import './searchByFiltersButton.scss';

type Props = {
  filters?: Record<string, any>[];
  prefixId: string;
  onClick: () => void;
};

export function SearchByFiltersButton({ filters, prefixId, onClick }: Readonly<Props>) {
  const amountOfActiveFilters = (filters ?? []).reduce((acc, filter) => {
    return acc + (filter.value?.length || 0);
  }, 0);

  return (
    <ButtonUI
      icon="fa-regular fa-sliders"
      id={`${prefixId}_searchByFiltersButton`}
      onClick={onClick}
      shape="squareRounded"
      type="secondary"
      {...(amountOfActiveFilters > 0 && {
        badge: {
          className: 'searchByFiltersButton__badge',
          content: amountOfActiveFilters
        }
      })}
    />
  );
}
